/* Pro Witgoed — voorraad/levertijd-block client-side renderer.
 *
 * Vervangt placeholders in de labels die je in Customize hebt ingesteld:
 *   [day]   → "morgen" / "overmorgen" / "maandag" / "dinsdag" / ...
 *   [time]  → live countdown HH:MM:SS tot 17:00 (alleen vóór cutoff)
 *
 * Twee dag-definities:
 *   - pickup-dag (ma t/m vr, niet feestdag) — pakketdienst pakt op
 *   - leverdag (ma t/m za, niet zondag, niet feestdag) — bezorging aan klant
 *
 * In-stock berekening:
 *   - vóór cutoff op pickup-dag       → pickup vandaag, levering = nextDeliveryDay(now)
 *   - na cutoff op pickup-dag         → pickup = volgende werkdag, levering daarna
 *   - geen pickup-dag (za/zo/feest)   → pickup = volgende werkdag, levering daarna
 *
 * Backorder: +N leverdagen (ma-za) vanaf vandaag.
 */
(function () {
  "use strict";

  var NL_HOLIDAYS = new Set([
    // 2026
    "2026-01-01", "2026-04-03", "2026-04-05", "2026-04-06", "2026-04-27",
    "2026-05-05", "2026-05-14", "2026-05-24", "2026-05-25",
    "2026-12-25", "2026-12-26",
    // 2027
    "2027-01-01", "2027-03-26", "2027-03-28", "2027-03-29", "2027-04-27",
    "2027-05-06", "2027-05-16", "2027-05-17",
    "2027-12-25", "2027-12-26",
  ]);

  var WEEKDAYS = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
  var MONTHS = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];

  /* PWS 12-10-2026 — DE DATUM STOND IN ELKE MARKT IN HET NEDERLANDS.
   * De labels eromheen komen uit de taalbestanden en waren wel vertaald, maar de dag- en
   * maandnaam werden hardcoded uit de twee lijstjes hierboven gehaald. Op /en/ las een klant
   * daardoor "No later than dinsdag 20 oktober at your door" en op /fr-be/ "Au plus tard
   * dinsdag 20 oktober chez vous". Nu komt de datum uit Intl, met de taal van de pagina.
   * Voor het Nederlands levert dat exact dezelfde tekst op ("dinsdag 20 oktober"), dus op de
   * hoofdmarkt verandert er niets. Valt Intl weg, dan blijven de lijstjes de terugval.
   * Duitsland raakt dit niet: dat heeft een eigen blok (snippets/pws-levering-de.liquid). */
  var LANG = (document.documentElement.getAttribute("lang") || "nl").slice(0, 2).toLowerCase();
  var LOCALE = { nl: "nl-NL", fr: "fr-BE", de: "de-DE", en: "en-GB" }[LANG] || "nl-NL";
  var RELATIEF = {
    nl: ["vandaag", "morgen", "overmorgen"],
    fr: ["aujourd'hui", "demain", "apr\u00e8s-demain"],
    de: ["heute", "morgen", "\u00fcbermorgen"],
    en: ["today", "tomorrow", "the day after tomorrow"],
  };
  function intlDatum(d, opties) {
    try {
      return new Intl.DateTimeFormat(LOCALE, opties).format(d);
    } catch (e) {
      return null;
    }
  }

  function isoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, "0");
    var dd = String(d.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + dd;
  }
  /** Pakketdienst pakt op: ma t/m vr, geen feestdag */
  function isPickupDay(d) {
    var dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return !NL_HOLIDAYS.has(isoDate(d));
  }
  /** Bezorgdag aan klant: ma t/m za, geen feestdag (zaterdag = ja, zondag = nee) */
  function isDeliveryDay(d) {
    if (d.getDay() === 0) return false;
    return !NL_HOLIDAYS.has(isoDate(d));
  }
  /** Eerstvolgende dag na `start` waarvoor `pred` true is */
  function nextDayWhere(start, pred) {
    var d = new Date(start.getTime());
    d.setDate(d.getDate() + 1);
    while (!pred(d)) d.setDate(d.getDate() + 1);
    return d;
  }
  /** N leverdagen vooruit vanaf `start` (excl. start zelf) */
  function addDeliveryDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isDeliveryDay(d)) added++;
    }
    return d;
  }
  function formatNlDate(d) {
    return intlDatum(d, { weekday: "long", day: "numeric", month: "long" })
      || WEEKDAYS[d.getDay()] + " " + d.getDate() + " " + MONTHS[d.getMonth()];
  }
  function dagNaam(d) {
    return intlDatum(d, { weekday: "long" }) || WEEKDAYS[d.getDay()];
  }
  function relativeDayName(target, now) {
    var todayMid = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var tgtMid   = new Date(target.getFullYear(), target.getMonth(), target.getDate());
    var diffDays = Math.round((tgtMid - todayMid) / (24 * 3600 * 1000));
    var rel = RELATIEF[LANG] || RELATIEF.nl;
    if (diffDays === 0) return rel[0];
    if (diffDays === 1) return rel[1];
    if (diffDays === 2) return rel[2];
    return dagNaam(target);
  }
  function pad2(n) { return String(n).padStart(2, "0"); }
  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function renderInStock(wrap, cutoffHour, cutoffMin) {
    var titleEl = wrap.querySelector("[data-pws-instock-title]");
    if (!titleEl) return;

    var tmplBefore  = titleEl.getAttribute("data-pws-tmpl-before")  || "";
    var tmplMissed  = titleEl.getAttribute("data-pws-tmpl-missed")  || "";
    var tmplWeekend = titleEl.getAttribute("data-pws-tmpl-weekend") || "";

    // Cutoff-flow geldt voor zowel DPD als eigen koerier (service): na 17:00
    // → pickup volgende werkdag → leverdag dag daarna. Klant ziet voor beide
    // flows hetzelfde "overmorgen leverbaar" patroon.
    var cdLine  = wrap.querySelector("[data-pws-cd-line]");
    var cdTimer = wrap.querySelector("[data-pws-cd-timer]");
    var cdDay   = wrap.querySelector("[data-pws-cd-day]");

    function tick() {
      var now = new Date();
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, cutoffMin, 0, 0);
      var todayIsPickup = isPickupDay(now);
      var pastCutoff = now >= cutoff;

      var template, deliveryDay, showTimer;

      if (todayIsPickup && !pastCutoff) {
        template = tmplBefore;
        deliveryDay = nextDayWhere(now, isDeliveryDay);
        showTimer = true;
      } else if (todayIsPickup && pastCutoff) {
        template = tmplMissed;
        var pickupMissed = nextDayWhere(now, isPickupDay);
        deliveryDay = nextDayWhere(pickupMissed, isDeliveryDay);
        showTimer = false;
      } else {
        template = tmplWeekend;
        var pickupWk = nextDayWhere(now, isPickupDay);
        deliveryDay = nextDayWhere(pickupWk, isDeliveryDay);
        showTimer = false;
      }

      // Voor before-cutoff: [day] = relatief ("morgen") want countdown maakt
      // het inherent kort. Voor missed/weekend (geen countdown): [day] = volledige
      // datum-string met hoofdletter ("Vrijdag 5 juni") — matcht categoriepagina.
      var dayName;
      if (showTimer) {
        dayName = relativeDayName(deliveryDay, now);
      } else {
        var raw = formatNlDate(deliveryDay);
        dayName = raw.charAt(0).toUpperCase() + raw.slice(1);
      }

      // Render title (in stock label). Met optionele [day] / [time]
      // placeholders voor backwards-compat met oudere templates.
      var html = template.replace(/\[day\]/g, esc(dayName));
      if (showTimer) {
        var totalSec = Math.max(0, Math.floor((cutoff - now) / 1000));
        var h = Math.floor(totalSec / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;
        var timeStr = pad2(h) + ":" + pad2(m) + ":" + pad2(s);
        html = html.replace(/\[time\]/g,
          '<strong class="pws-stock-delivery__countdown">' + timeStr + '</strong>');
      } else {
        html = html.replace(/\s*\[time\]\s*/g, " ").trim();
      }
      titleEl.innerHTML = html;

      // Doorgeven aan blokken elders op de pagina; zie pws-stock-delivery.liquid.
      var uitInstock = wrap.querySelector("[data-pws-leverdag]");
      if (uitInstock) uitInstock.textContent = dayName;

      // Separate countdown line — alleen vóór cutoff op werkdag
      if (cdLine) {
        if (showTimer) {
          cdLine.hidden = false;
          if (cdTimer) {
            var ts = Math.max(0, Math.floor((cutoff - now) / 1000));
            cdTimer.textContent = pad2(Math.floor(ts / 3600))
              + ":" + pad2(Math.floor((ts % 3600) / 60))
              + ":" + pad2(ts % 60);
          }
          if (cdDay) cdDay.textContent = dayName;
        } else {
          cdLine.hidden = true;
        }
      }
    }

    tick();

    // Live ticker: nodig als showTimer ooit true is OF als [time] in een
    // template staat (legacy). De cd-line zelf maakt het altijd nodig op
    // werkdagen vóór cutoff.
    var interval = setInterval(tick, 1000);
    var observer = new MutationObserver(function () {
      if (!document.body.contains(wrap)) {
        clearInterval(interval);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /** Qty-aware toggle voor in_stock state.
   *
   *  state="in_stock" betekent stock_denbosch > 0. Bij qty > stock_denbosch
   *  switchen we naar de "qty-mixed"-body: stock_denbosch stuks snel (uit
   *  Den Bosch), rest via NOD (lange levertijd). Klant ziet beide regels
   *  zodat de verwachting klopt en hij kan beslissen (qty terug naar 1, of
   *  accepteren).
   */
  function capitalizeFirst(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function computeFastDeliveryDate(wrap) {
    // Zelfde regels als renderInStock: pickup-cutoff + nextDeliveryDay
    var cutoffHour = parseInt(wrap.getAttribute("data-pws-cutoff-hour") || "17", 10);
    var cutoffMin = parseInt(wrap.getAttribute("data-pws-cutoff-minute") || "0", 10);
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, cutoffMin, 0, 0);
    var todayIsPickup = isPickupDay(now);
    var pastCutoff = now >= cutoff;
    if (todayIsPickup && !pastCutoff) {
      return nextDayWhere(now, isDeliveryDay);
    }
    var pickup = nextDayWhere(now, isPickupDay);
    return nextDayWhere(pickup, isDeliveryDay);
  }

  function applyQtyForInStock(wrap) {
    var state = wrap.getAttribute("data-pws-state");
    if (state !== "in_stock") return;
    var mixedBody = wrap.querySelector("[data-pws-body-qty-mixed]");
    if (!mixedBody) return; // alleen aanwezig als nod > 0

    var stockDb = parseInt(wrap.getAttribute("data-pws-stock-denbosch") || "0", 10);
    var backorderDays = parseInt(wrap.getAttribute("data-pws-backorder-days") || "8", 10);

    var form = document.querySelector('form[action*="/cart/add"]');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || "1", 10)) : 1;

    var useMixed = qty > stockDb && stockDb > 0;
    // Edge: qty > stockDb maar stockDb == 0 mag eigenlijk niet in_stock zijn,
    // we negeren die hier (renderInStock heeft state="in_stock" gechecked).

    wrap.querySelectorAll("[data-pws-body-instock]").forEach(function (el) { el.hidden = useMixed; });
    wrap.querySelectorAll("[data-pws-body-qty-mixed]").forEach(function (el) { el.hidden = !useMixed; });

    if (useMixed) {
      wrap.classList.remove("pws-stock-delivery--in_stock");
      wrap.classList.add("pws-stock-delivery--backorder"); // hergebruik backorder-tint
    } else {
      wrap.classList.add("pws-stock-delivery--in_stock");
      wrap.classList.remove("pws-stock-delivery--backorder");
    }

    if (useMixed) {
      var fast = stockDb;
      var slow = qty - stockDb;
      var fastDate = computeFastDeliveryDate(wrap);
      var slowDate = addDeliveryDays(new Date(), backorderDays);

      var setText = function (sel, val) {
        var el = wrap.querySelector(sel);
        if (el) el.textContent = val;
      };
      setText("[data-pws-qty-mixed-fast-count]", String(fast));
      setText("[data-pws-qty-mixed-fast-suffix]", fast === 1 ? "stuk" : "stuks");
      setText("[data-pws-qty-mixed-fast-date]", capitalizeFirst(formatNlDate(fastDate)));
      setText("[data-pws-qty-mixed-slow-count]", String(slow));
      setText("[data-pws-qty-mixed-slow-suffix]", slow === 1 ? "stuk" : "stuks");
      setText("[data-pws-qty-mixed-slow-date]", formatNlDate(slowDate));
    }
  }

  /** Hangt een listener op de qty-input zodat we live wisselen.
   *  Dawn `<quantity-input>` dispatcht 'change' bij +/- klikken én typen. */
  function attachQtyListener(wrap) {
    var form = document.querySelector('form[action*="/cart/add"]');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    if (!qtyInput || qtyInput.dataset.pwsBound === "1") return;
    qtyInput.dataset.pwsBound = "1";
    var handler = function () { applyQtyForInStock(wrap); };
    qtyInput.addEventListener("change", handler);
    qtyInput.addEventListener("input", handler);
  }

  function renderBackorder(wrap, backorderDays) {
    var dateEl = wrap.querySelector("[data-pws-backorder-date]");
    if (!dateEl) return;
    var delivery = addDeliveryDays(new Date(), backorderDays);
    dateEl.textContent = formatNlDate(delivery);
    var uitBackorder = wrap.querySelector("[data-pws-leverdag]");
    if (uitBackorder) uitBackorder.textContent = formatNlDate(delivery);
  }

  function init(wrap) {
    var state = wrap.getAttribute("data-pws-state");
    if (state === "in_stock") {
      var h = parseInt(wrap.getAttribute("data-pws-cutoff-hour") || "17", 10);
      var m = parseInt(wrap.getAttribute("data-pws-cutoff-minute") || "0", 10);
      renderInStock(wrap, h, m);
      // Qty-aware: switch naar backorder-body bij qty > stock_denbosch
      applyQtyForInStock(wrap);
      attachQtyListener(wrap);
    } else if (state === "backorder") {
      var n = parseInt(wrap.getAttribute("data-pws-backorder-days") || "8", 10);
      renderBackorder(wrap, n);
    }
  }

  function initAll() {
    var wraps = document.querySelectorAll(".pws-stock-delivery");
    for (var i = 0; i < wraps.length; i++) {
      if (!wraps[i].dataset.pwsInited) {
        wraps[i].dataset.pwsInited = "1";
        init(wraps[i]);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  var ro = new MutationObserver(initAll);
  ro.observe(document.body, { childList: true, subtree: true });
})();
